// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"4ff34aed","628":"9a02c945"}[chunkId] + ".chunk.js";
};